<template>
  <div>
    <div v-if="loaded" >
      <h3 class="overlay-size"> {{this.bits}} </h3>
    </div>
    <div v-else>
      Loading....
    </div>

  </div>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'DailySubGoalView',

  data: () => ({
    bits: 0,
    loaded: false,
  }),
  components: {
  },
  mounted() {
    this.intervalId = window.setInterval(this.updateTimer, 2500);
    this.updateTimer();
  },
  computed: {
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    updateTimer() {
      BackendService.loadBitGoals(this.$router.currentRoute.params.token).then((data) => {
        // console.log(data.data);
        this.loaded = true;
        this.bits = data.data.bits;
      });
    },
  },
};

</script>

<style lang="scss">
.transparent.theme--dark.v-application {
  background-color: transparent;
  color: inherit;
}

html {
  overflow: auto;
}

.overlay-size {
  font-size: 60px;
}
</style>
